import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateContract } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateContract,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.contracts._def }),
    });
};
